import { call } from 'redux-saga/effects'
import fetchService from './fetchService'

export const fetching = name => `${name}/fetching`
export const fulfilled = name => `${name}/fulfilled`
export const rejected = name => `${name}/rejected`
export const clear = name => `${name}/clear`

export const dataRequest = name => {
  return {
    type: fetching(name),
  }
}

export const dataSuccess = (name, payload) => {
  return {
    type: fulfilled(name),
    payload,
  }
}

export const dataError = name => {
  return {
    type: fulfilled(name),
  }
}

export default function* fetchData(name, service) {
  yield call(fetchService, service, {
    request: () => dataRequest(name),
    success: data => dataSuccess(name, data),
    error: () => dataError(name),
  })
}

const fetchInit = {
  fetching: false,
  data: undefined,
  error: false,
}

export const createFetchReducer = ({ name, init = {}, otherCases = state => state }) => (
  state = { ...fetchInit, ...init },
  action,
) => {
  switch (action.type) {
    case fetching(name):
      return {
        ...state,
        fetching: true,
        error: false,
      }
    case fulfilled(name):
      return {
        ...state,
        fetching: false,
        data: action.payload,
      }
    case rejected(name):
      return {
        ...state,
        fetching: false,
        error: true,
      }
    case clear(name):
      return {
        ...state,
        ...fetchInit,
      }
    default:
      return otherCases(state, action)
  }
}
